export const arrayLengthWithoutEmpty = (array: any[]) => {
   let trueLength = 0;
   if (!array) return trueLength;
   trueLength = array.filter((item) => item).length;
   return trueLength;
};
